import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function PageHero({
  eyebrow,
  title,
  intro,
  accent = "#FFD700",
  ctaLabel,
  ctaTo,
  ctaExternal,
  secondaryLabel,
  secondaryTo,
}) {
  return (
    <section className="relative overflow-hidden border-b-2 border-[#1A1A1A] bg-white">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-16 md:py-24">
        <div className="inline-flex items-center gap-2 bg-white border-2 border-[#1A1A1A] rounded-full px-3 py-1 nb-shadow-sm">
          <span
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: accent }}
          />
          <span className="text-xs font-bold tracking-[0.2em] uppercase">
            {eyebrow}
          </span>
        </div>
        <h1 className="mt-5 font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tighter text-[#1A1A1A] max-w-4xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 text-lg md:text-xl text-[#4A4A4A] font-medium leading-relaxed max-w-3xl">
            {intro}
          </p>
        )}
        {(ctaLabel || secondaryLabel) && (
          <div className="mt-8 flex flex-wrap gap-3">
            {ctaLabel &&
              (ctaExternal ? (
                <a
                  href={ctaTo}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="page-hero-cta-btn"
                  className="inline-flex items-center gap-2 bg-[#0055FF] text-white border-2 border-[#1A1A1A] rounded-full px-6 py-3 font-bold uppercase tracking-wide nb-shadow nb-press"
                >
                  {ctaLabel} <ArrowUpRight size={16} strokeWidth={2.5} />
                </a>
              ) : (
                <Link
                  to={ctaTo}
                  data-testid="page-hero-cta-btn"
                  className="inline-flex items-center gap-2 bg-[#0055FF] text-white border-2 border-[#1A1A1A] rounded-full px-6 py-3 font-bold uppercase tracking-wide nb-shadow nb-press"
                >
                  {ctaLabel} <ArrowUpRight size={16} strokeWidth={2.5} />
                </Link>
              ))}
            {secondaryLabel && (
              <Link
                to={secondaryTo}
                data-testid="page-hero-secondary-btn"
                className="inline-flex items-center gap-2 bg-[#FFD700] text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-full px-6 py-3 font-bold uppercase tracking-wide nb-shadow nb-press"
              >
                {secondaryLabel}
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
